import Schema from 'validate';
import isEmail from 'validator/lib/isEmail';

import personSchema from '../../../../../lib/paths/person_FULL_Paths.json';
const P = personSchema.attributes;

const mailValidator = (val: string) => isEmail(val);

const PersonalDataValidator = new Schema({
	[P.Personenbezogene_Daten_Anrede.path]: {
		type: String,
	},
	[P.Personenbezogene_Daten_Titel.path]: {
		type: String,
	},
	[P.Personenbezogene_Daten_Vorname.path]: {
		type: String,
		required: true,
	},
	[P.Personenbezogene_Daten_Nachname.path]: {
		type: String,
		required: true,
	},
	// [P.Adressdaten_Strasse.path]: {
	// 	type: String,
	// 	required: true,
	// },
	// [P.Adressdaten_Hausnummer.path]: {
	// 	type: String,
	// 	required: true,
	// },
	// [P.Adressdaten_Adresszusatz.path]: {
	// 	type: String,
	// },
	// [P.Adressdaten_Bezeichnung.path]: {
	// 	type: String,
	// },
	// [P.Adressdaten_PLZ.path]: {
	// 	type: String,
	// 	required: true,
	// },
	// [P.Adressdaten_Ort.path]: {
	// 	type: String,
	// 	required: true,
	// },
	[P.Kontaktdaten_E_Mail.path]: {
		type: String,
		required: true,
		use: { mailValidator },
		message: {
			mailValidator: 'Ungültige E-Mail-Adresse.',
		},
	},
	// [P.Kontaktdaten_Fax]: {
	// 	type: String,
	// },
	[P.Kontaktdaten_Telefon.path]: {
		type: String,
		required: true,
		use: {
			phone: (val: string) => /^[0-9\s]*$/.test(val),
		},
		message: {
			phone: 'Diese Telefonnummer ist ungültig. Es sind nur Zahlen und Leerzeichen erlaubt.',
		},
	},
	// [P.Kontaktdaten_Webadresse.path]: {
	// 	type: String,
	// },
});

PersonalDataValidator.message({
	required: (_path: string) => 'Dies ist ein Pflichtfeld.',
	type: (path: string) =>
		`Das Formular ist fehlerhaft, bitte melden Sie diesen Fehler. Geben Sie als Grund "falscher Datentyp, ${path}" an.`,
});

export default PersonalDataValidator;
